import { CssBaseline } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { ThemeProvider as MUIThemeProvider } from '@material-ui/styles';
import React from 'react';
import { muiThemeDark } from '../../../muiTheme';
import LoadingIndicator from '../../core/LoadingIndicator';

export default () => (
  <MUIThemeProvider theme={muiThemeDark}>
    <CssBaseline />
    <Box display="flex" flex={1} alignItems="center" justifyContent="center">
      <LoadingIndicator />
    </Box>
  </MUIThemeProvider>
);
